import React, { useEffect, useState } from "react";
import Avatar from "../../../../components/img/no_avatar.png";
import strahovanie from "../../../../icons-office/strahovanie.svg"
import "./child-client.scss";
import Button from "@material-ui/core/Button";
import TimetableClient from "./components/timetable-client/timetable-client";
import InvoicesClient from "./components/invoices-client/invoices-client";
import { AntTabs } from "../../../../.TrainerOffice/components/training-trainer/training-trainer";
import PropTypes from "prop-types";
import EventsClient from "./components/events-client/events-client";
import { withStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import { compose } from "redux";
import withApiService from "../../../../components/hoc/with-api-service";
import { withRouter } from "react-router";
import { getChildUserSelector } from "../../../../selectors/users-selectors";
import { useSelector } from "react-redux";
import ChangePhoto from "../../modal/changePhoto";
import SaveDocument from "../../modal/save-document";
import Badge from "@material-ui/core/Badge";
import { makeStyles } from "@material-ui/styles";
import {Link} from "react-router-dom";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>
          <span>{children}</span>
        </div>
      )}
    </div>
  );
}

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    marginRight: "15px",
    fontSize: "20px",
    fontWeight: 700,
    [theme.breakpoints.down("xs")]: {
      fontSize: "15px",
    },
    fontFamily: [
      "Apple SD Gothic Neo",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },
    "&:focus": {
      color: "#454545",
    },
  },
}))((props) => <Tab disableRipple {...props} />);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  badge: {
    backgroundColor: "#7C7C7C",
  },
}));

const ChildClient = (props) => {
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const child = useSelector((state) => getChildUserSelector(state, props.id));
  const [openDocument, setOpenDocument] = useState(false);
  const collection = "Children.photo";
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    document.title = `${child?.last_name} ${child?.first_name}`;
  }, [child]);


  return (
    <div className="childContainer">
      <div className="headerChildContainer">
        <div className="headerMainChild">
          <h2>Главная</h2>
          <span>Главная-{child.first_name}</span>
        </div>
        <div className="headerChild">
          <div
            className="avatarChildClient"
            onClick={() => setOpen(!open)}
            style={{
              backgroundImage: `url(${child.avatar?.full_url || Avatar})`,
            }}
          />
          <div className="headerChildName">
            <div className="headerChildNameHeader">
              <h1>{child.last_name}</h1>
              <h1 style={{ fontWeight: 400 }}>{child.first_name}</h1>
              <h1 style={{ fontWeight: 400 }}>{child.middle_name || ""}</h1>
            </div>
            <div className="headerChildNameFooter">
              <span>{child.birthday}</span>
              <span>{child.age} лет</span>
            </div>
            <div className="fileChildContainer">
              {child.documents?.length > 0 ? (
                <Badge
                  badgeContent={child.documents.length}
                  classes={{ badge: classes.badge }}
                >
                  <Button
                    onClick={() => {
                      setOpenDocument(!open);
                    }}
                  >
                    DOC
                  </Button>
                </Badge>
              ) : (
                <Button
                  onClick={() => {
                    setOpenDocument(!open);
                  }}
                >
                  DOC
                </Button>
              )}
              <Button className="transparency-btn" onClick={() => {
                props.history.push("/client/strhovanie")
              }}>
                <img src={strahovanie} alt="strahovanie image"/>
              </Button>
            </div>
          </div>
        </div>
        {/*<div className="eventsChild">
          <EventsClient />
        </div>*/}
      </div>
      <div className="contentChild">
        <AntTabs value={value} onChange={handleChange} aria-label="ant example">
          <AntTab label="Расписание" index={0} value={0} />
          <AntTab label="Абонементы" index={1} value={1} />
          <AntTab
            label="События"
            index={2}
            value={2}
            className="eventAntTabChild"
          />
        </AntTabs>
        <TabPanel value={value} index={0}>
          <TimetableClient
            schedule={child.schedule}
            child_id={child.id}
            child={child}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <InvoicesClient
            invoices={child.invoices}
            child_id={child.id}
            child={child}
          />
        </TabPanel>
        <TabPanel value={value} index={2} className="eventAntTabChild">
          <EventsClient />
        </TabPanel>
      </div>
      {open && (
        <ChangePhoto
          open={open}
          setOpen={setOpen}
          item={child}
          collection={collection}
        />
      )}
      {openDocument && (
        <SaveDocument
          open={openDocument}
          setOpen={setOpenDocument}
          child={child}
        />
      )}
    </div>
  );
};

export default compose(withApiService())(withRouter(ChildClient));
